(function () {
  'use strict';
  var current;
  function mount() {
    var header = document.querySelector('.wcy-essential-header');
    if (current && current.header === header) return;
    if (current) { current.destroy(); current = null; }
    if (!header) return;
    var section = header.closest('.shopify-section-main-header'), menu = section.querySelector('#mobileMenu');
    var button = header.querySelector('#nav-menu-btn .navbar-toggler');
    if (!menu || !button) return;
    var desktop = matchMedia('(min-width:1025px)'), frame = 0;
    function categories() {
      if (!desktop.matches || !menu.querySelector('#menu-view')) return;
      menu.querySelectorAll('.menu-tab').forEach(function (tab) { tab.classList.toggle('active', tab.dataset.tab === '#menu-view'); });
      menu.querySelectorAll('.tabcontent').forEach(function (panel) { panel.classList.toggle('hidden', panel.id !== 'menu-view'); });
    }
    function update() {
      frame = 0;
      document.body.style.setProperty('--wcy-navigation-top', Math.max(0, Math.round(header.getBoundingClientRect().bottom)) + 'px');
      button.setAttribute('aria-expanded', String(document.body.classList.contains('nav-open')));
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(update); }
    function close(restoreFocus) {
      var nativeClose = menu.querySelector('.close-btn');
      if (nativeClose) nativeClose.click();
      document.body.classList.remove('nav-open');
      if (restoreFocus) button.focus({ preventScroll: true });
      schedule();
    }
    function click(event) {
      if (button.contains(event.target)) {
        categories(); update();
        if (document.body.classList.contains('nav-open')) {
          event.preventDefault(); event.stopImmediatePropagation(); close(true);
        }
      }
    }
    function pointer(event) {
      if (document.body.classList.contains('nav-open') && !menu.contains(event.target) && !button.contains(event.target)) close(false);
    }
    function key(event) {
      if (event.key === 'Escape' && document.body.classList.contains('nav-open')) { event.preventDefault(); close(true); }
    }
    function modeChanged() { categories(); schedule(); }
    button.setAttribute('aria-controls', 'mobileMenu');
    var closeButton = menu.querySelector('.close-btn');
    if (closeButton) { closeButton.setAttribute('aria-label', 'Luk menu'); closeButton.setAttribute('tabindex', '0'); }
    var size = new ResizeObserver(schedule); size.observe(header);
    var state = new MutationObserver(schedule); state.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    var position = new MutationObserver(schedule); position.observe(section, { attributes: true, attributeFilter: ['class', 'style'] });
    document.addEventListener('click', click, true); document.addEventListener('pointerdown', pointer, true); document.addEventListener('keydown', key);
    addEventListener('resize', schedule); addEventListener('scroll', schedule, { passive: true }); desktop.addEventListener('change', modeChanged);
    categories(); update();
    current = { header: header, section: section, destroy: function () {
      size.disconnect(); state.disconnect(); position.disconnect(); cancelAnimationFrame(frame);
      document.removeEventListener('click', click, true); document.removeEventListener('pointerdown', pointer, true); document.removeEventListener('keydown', key);
      removeEventListener('resize', schedule); removeEventListener('scroll', schedule); desktop.removeEventListener('change', modeChanged);
      document.body.classList.remove('nav-open'); document.body.style.removeProperty('--wcy-navigation-top');
    } };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:section:unload', function (event) { if (current && event.target.contains(current.header)) { current.destroy(); current = null; } });
})();
